import { createFileRoute } from '@tanstack/react-router'
import { ControlRoomPage } from '@features/projects/components/WorkflowSessionPage/ControlRoomPage'

const ControlRoomSessionRoute = () => {
  return <ControlRoomPage />
}

export const Route = createFileRoute(
  '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/control'
)({
  component: ControlRoomSessionRoute,
  loader: () => ({
    crumb: 'Control',
  }),
})
